import { alpha } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  leftIcon: {
    marginRight: theme.spacing(2),
  },
  noPadding: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  header: {
    borderTop: `2px solid ${alpha(theme.palette.action.disabledBackground, 0.05)}`,
    marginBottom: `-${theme.spacing(1)}`,
    marginTop: `${theme.spacing(1)}`,

    '& .div1': {
      marginLeft: '3%',
    },
    '& .div2': {
      marginLeft: 'auto',
      marginRight: theme.spacing(2),
    },
    '& .typeFilters': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    }
  },
  imageIcon: {
    position: 'absolute',
    bottom: 2,
    right: 2,
    color: theme.colors.white,
  },
  topList: {
    borderColor: theme.palette.action.disabled,
    borderBottomWidth: 2,
  },
  topBar: {
    backgroundColor: theme.palette.action.disabledBackground,
    margin: '5px 10px 0 10px',
    height: 2,
  },
  button: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  expandButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),

    '& span': {
      display: 'flex',
      alignItems: 'center',
      maxHeight: '21px',
      overflow: 'visible',
    },
  },
  subText: {
    display: 'block',
    fontSize: 12,
  },
  textRow: {
  },
  flexrow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',

    '& > div > .MuiTypography-root': {
      width: `calc(100% - ${theme.spacing(12)})`,
    },
  },
  leftIconWrap: {
    '& button': {
      padding: p => p.isMobile ? 0 : theme.spacing(1),
      marginRight: p => p.isMobile ? 5 : 0,
    }
  },
  ItemContainerWithImage: {
    minHeight: 125,
  },
  ItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderTop: p => p.readOnly ? 'none' : `2px solid ${alpha(theme.palette.action.disabledBackground, 0.05)}`,
    pointerEvents: p => p.readOnly ? 'none' : 'auto',

    '& .daterow': {
      fontSize: 12,
      marginLeft: 'auto',
      fontWeight: '400',
      fontStyle: 'italic',
    },

    '& .traderow': {
      display: 'flex',
      flexWrap: 'wrap',
      fontSize: 12,
      marginLeft: 'auto',
      fontWeight: '400',
      '& span': {
        padding: "2px 8px",
        borderRadius: 12,
        marginBottom: "4px",
        marginRight: "4px",
        backgroundColor: '#ebebeb',
        color: '#222'
      },
      '& span:first-child': {
        marginLeft: '-4px',
      },
    },

    '& .MuiListItemText-primary': {
      fontWeight: 'bold',
      marginBottom: theme.spacing(1),
    },

    '& .MuiTypography-colorTextSecondary': {
      color: theme.palette.text.primary,
    },
  },
  expandContainer: {
    marginLeft: 48,
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
  },
  pad: {
    paddingTop: theme.spacing(1),
  },
  tagContainer: {
    '& p': {
      marginBlock: `${theme.spacing(1)} !important`,
    },
  },
  imageRow: {
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
    overflowX: 'auto',
  },
  padRow: {
    padding: theme.spacing(2),
  },
  padLeft: {
    paddingLeft: 56,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
    },
  },
  secondaryAction: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    height: `calc(100% - ${theme.spacing(2)})`,
  }
}));

export default useStyles;
